import { render, staticRenderFns } from "./EditableValue.vue?vue&type=template&id=4effe655&scoped=true&"
import script from "./EditableValue.vue?vue&type=script&lang=js&"
export * from "./EditableValue.vue?vue&type=script&lang=js&"
import style0 from "./EditableValue.vue?vue&type=style&index=0&id=4effe655&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4effe655",
  null
  
)

export default component.exports